import { Component, input } from '@angular/core';
import { SpinnerComponent } from '@shared/components/spinner/spinner.component';

/**
 * Full-page loading overlay. Covers the whole viewport with a blurred scrim,
 * the branded spinner, and an optional dynamic message that the host can update
 * as a multi-step process progresses.
 */
@Component({
  selector: 'app-loading-overlay',
  standalone: true,
  imports: [SpinnerComponent],
  template: `
    <div class="loading-overlay" role="status" aria-live="polite">
      <app-spinner size="lg" />
      @if (message()) {
        <p class="loading-message">{{ message() }}</p>
      }
    </div>
  `,
  styleUrl: './loading-overlay.component.scss',
})
export class LoadingOverlayComponent {
  /** Message shown beneath the spinner. Update it to reflect the current step. */
  message = input<string>('');
}
